export function isStorybookEnvironment(): boolean {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return !!window.IS_STORYBOOK;
}

export function isE2ETestEnvironment(): boolean {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return !!window.IS_PLAYWRIGHT;
}
